<template>
  <div>
    <label
      v-if="label !== false"
      class="flex items-center justify-between leading-6 font-bold text-primary-900 dark:text-white/80"
      :class="[size === 'xl' ? 'text-xl' : size === 'lg' ? 'text-lg' : 'text-sm']">
      <span>{{ label }}<span v-if="optional" class="font-normal text-muted"> (optional)</span></span>
      <span v-if="$slots['label-suffix']" class="flex items-center">
        <slot name="label-suffix" />
      </span>
    </label>
    <div :class="[!label ? '' : size === 'xl' ? 'mt-8' : size === 'lg' ? 'mt-6' : 'mt-2']">
      <slot />
    </div>
    <div class="mt-2 text-sm text-primary-500/80 dark:text-white/40" v-if="$slots.description">
      <slot name="description" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { toRefs } from 'vue'

const props = defineProps({
  label: [String, Boolean],
  optional: Boolean,
  size: { type: String, default: 'md' }
})
const { label, optional, size } = toRefs(props)
</script>
